module["exports"] = [
  "Nederland"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nl/address/default_country.js
// module id = 2543
// module chunks = 2